export default __webpack_public_path__ + "static/media/english-icon.1c87e359.webp";